import { useState} from "react";
import {CommonDialogBox} from "components";
import { Button, DialogProps } from '@mui/material';
import LinearProgress from '@material-ui/core/LinearProgress';
import AlertNotification from "components/AlertNotification";
import TextField from '@mui/material/TextField';
import * as Utils from "services/UtilsService";
import AuthService from "services/AuthService";
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store';
import { closeDialog, showNotification, updateTeam, incrementActiveUser} from 'store/main/userManagement';
import jwtService from 'services/jwtService';



const UserAdd = () => {
    const dispatch = useDispatch();
    const state = useSelector((state:RootState) => state.main.addMember.state)
    const productSelected = useSelector((state:RootState) => state.main.addMember.options.product)
    const subscriptionReference = useSelector((state:RootState) => state.main.addMember.options.subscription)
    const notification = useSelector((state:RootState) => state.main.addMember.notification)
    //const team = useSelector((state:RootState) => state.main.addMember.team)

    const [loading, setLoading] = useState(false)
    const [showError, setShowError] = useState(false);
    const [showSuccess, setShowSuccess] = useState(false);
    const [emailError, setEmailError] = useState(false);
    const [helperText, setHelperText] = useState("");
    const [confirmEmailError, setConfirmEmailError] = useState(false);
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [confirmEmail, setConfirmEmail] = useState('');
    const [helperTextConfirm, setHelperTextConfirm] = useState("");

    const handleEmail = (email:string) => {
        setEmail(email)
        if(Utils.validateEmail(email)){
            setEmailError(false);
            setHelperText("");
        }else{
            setEmailError(true);
            setHelperText("Invalid email format");
        }
    }

    const handleConfirmEmail = (email:string) => {
        setConfirmEmail(email)
        if(Utils.validateEmail(email)){
            setConfirmEmailError(false);
            setHelperTextConfirm("");
        }else{
            setConfirmEmailError(true);
            setHelperTextConfirm("Invalid email format");
        }
    }

    const handleReset = () => {
        setHelperText('')
        setHelperTextConfirm('')
        setEmailError(false)
        setConfirmEmailError(false)
        setEmail('')
        setConfirmEmail('')
    }

    const submitUser = async () => {
        dispatch(showNotification())
        setLoading(true)
        setShowError(false)
        setShowSuccess(false)
        if(email !== confirmEmail){
            setMessage("The two emails don't match")
            setShowError(true)
            setShowSuccess(false)
            setLoading(false)
            return false
        }
       
        if(email === '' || confirmEmail === ''){
            setMessage("All fields are required")
            setShowError(true)
            setShowSuccess(false)
            setLoading(false)
            return false
        }
        if(emailError || confirmEmailError)
            return false;

        //Check if the user is already memeber
        isAlreadyMember(email);

    }

    const addMember = async (userid : number, productSelected : string, subscriptionReference : string, member : string) => {

        try{
            const endpoint = process.env.REACT_APP_BASE_URL + '/customer/addmember';
            let response = await jwtService.fetchRequest({
                method: 'POST',
                url: endpoint,
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                "data": {
                    userid : userid, 
                    product : productSelected,  
                    subscriptionReference  : subscriptionReference, 
                    member : btoa(member), 
                    email : btoa(AuthService.userEmail),
                    key_id : process.env.REACT_APP_BASE_APIKEY
                }
            });

            if(response.data.action === 'success'){
                setMessage("The member has been successfully created.")
                getMyTeam()
                dispatch(showNotification())
                dispatch(incrementActiveUser())
                setShowError(false)
                setShowSuccess(true)
                handleReset()
                setLoading(false)
            }else{
                dispatch(showNotification())
                setMessage("There is an error to add this member. Please try again later or contact us!")
                setShowError(true)
                setShowSuccess(false)
                setLoading(false)
            }

        }catch(err) {
            console.log(err);
            dispatch(showNotification())
            setMessage("There is an error to add this member. Please try again later or contact us!")
            setShowError(true)
            setShowSuccess(false)
            setLoading(false)
        }
    }

    const getMyTeam = async () => {

        try{
            const endpoint = process.env.REACT_APP_BASE_URL + '/v2/customer/myusers';
            let response = await jwtService.fetchRequest({
                method: 'POST',
                url: endpoint,
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                "data": {email : btoa(AuthService.userEmail), key_id : process.env.REACT_APP_BASE_APIKEY}
            });
         
            if(response.data){
                dispatch(updateTeam(response.data.data))  
            }

        }catch(err) {
            console.log(err);
        }
    }

    //Check if the user is already member
    const isAlreadyMember = async (member : string) => {
        //GET UID OF THE ADMIN
        const endpoint = process.env.REACT_APP_BASE_URL + '/customer/ismember';

        try{
            let response = await jwtService.fetchRequest({
                method: 'POST',
                url: endpoint,
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                "data": {email : btoa(AuthService.userEmail), member : btoa(member),  key_id : process.env.REACT_APP_BASE_APIKEY}
            });
          
            
            if(response.data.error === false){

                if(response.data.nb > 0){
                    dispatch(showNotification())
                    setMessage("A user with this email already exists!");
                    setShowError(true);
                    setShowSuccess(false);
                    setLoading(false)
                    return false;
                }else{
                    addMember(response.data.userid, productSelected, subscriptionReference, member);
                    return true;
                }

            }else{
                dispatch(showNotification())
                setMessage("Error to add this member, try out later or contact us!")
                setShowError(true);
                setShowSuccess(false);
                setLoading(false)
                return false;
            }
        }catch(e){
            console.log(e);
            dispatch(showNotification())
            setMessage("Error to add this member, try out later or contact us!")
            setShowError(true);
            setShowSuccess(false);
            setLoading(false)
            return false;
        }
    }
 
    const closeComposeDialog: DialogProps["onClose"] = (event, reason) => {
        dispatch(closeDialog({showNotification:false}))
    }

    const DialogAction = () => {
        return (
            <div style={{padding: '0 15px'}}>
                <Button onClick={handleReset}>reset</Button>
                <Button 
                    type="submit" 
                    onClick={submitUser}  
                    variant="contained"
                    color="primary"
                >
                    Submit
                </Button>
            </div>
        )
    }

    return (
        <CommonDialogBox
            classes={{
                paper: 'm-24 rounded-8 white-bg'
            }}
            open={state}
            handleClose={closeComposeDialog}
            fullWidth
            maxWidth="sm"
            subtitle1='Add New User'
            titleh5=''
            dialogAction={<DialogAction />}
            displayScrollBar={true}
            maxHeight={600}
        >
            { loading ? <LinearProgress color="primary" /> : '' }
            { notification && showError ? 
                    <AlertNotification variant={"standard"} type={"error"} message={message} /> : ''
            }
            {
                notification && showSuccess ? 
                <AlertNotification variant={"standard"} type={"success"} message={message} />
                :
                ''
            }    
            <TextField
                required
                margin="dense"
                id="email"
                name="email"
                label="Email Address"
                type="email"
                error={emailError}
                helperText={helperText}
                fullWidth
                color='primary'
                variant="outlined"
                value={email}
                onChange={e => handleEmail(e.target.value)}
            />
            <TextField
                required
                margin="dense"
                id="confirmEmail"
                name="confirmEmail"
                label="Confirm Email"
                type="email"
                fullWidth
                value={confirmEmail}
                error={confirmEmailError}
                helperText={helperTextConfirm}
                color='primary'
                variant="outlined"
                onChange={e => handleConfirmEmail(e.target.value)}
            />                        
        </CommonDialogBox>   
    );
};

export default UserAdd;
